var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-client-btn',{attrs:{"agency-id":_vm.agencyId}},[_c('span',{staticClass:"q-ml-sm"},[_vm._v("Add Account")])]),_c('clients-table',{staticClass:"q-mt-md",attrs:{"agency-id":_vm.agencyId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }